/**
 * The download journal of ONE version, as a dialog opened from the version.
 *
 * Who asked for which file of this version, from where, and whether they got
 * it — grants and refusals in the same table, because the refusals are the
 * half anyone actually needs after an incident. It is the same embedded
 * `ReleaseDownloadsPanel`, narrowed to the version server-side, that used to
 * sit at the bottom of every opened version card; as a dialog behind a
 * button it is one click from the version it is asked about without making
 * every visit to a version a scroll past a table.
 */
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import type { JSX } from "react";

import { ReleaseDownloadsPanel } from "./ReleaseDownloadsPanel.js";
import type { ReleaseDTO } from "./releases-api.js";

interface Props {
  release: ReleaseDTO;
  open: boolean;
  onClose: () => void;
}

export function ReleaseDownloadJournalDialog({ release, open, onClose }: Props): JSX.Element {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Download journal — {release.version}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14, mb: 2 }}>
          Who asked for a file of this version, when, and whether they got it. Every attempt is
          recorded, refusals included.
        </DialogContentText>
        <ReleaseDownloadsPanel releaseId={release.id} version={release.version} embedded />
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="inherit" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
